import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { first } from 'rxjs/operators'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { DialogService, TagTiersService } from '../../../../../services'


const KEY = 'dossier-alerte-dialog'

@Component({
    selector: 'atyl-dossier-alerte-dialog',
    templateUrl: './dossier-alerte-dialog.component.html',
    styleUrls: ['./dossier-alerte-dialog.component.scss']
})
@Stringable({
    path: 'views/partials/layout/dialogs/dossier-alerte-dialog',
    key: KEY,
})
export class DossierAlerteDialogComponent extends BaseDialogComponent implements OnInit {
    @StringableValues(KEY)
    strings: any
    tags: any = [];
    result: any = {
        id: '',
        libelle: '',
        alerte: {
            id: '',
            tag: '',
            tiers: '',
        }
    };
    showListOfAlerts: boolean

    constructor(
        public dialogRef: MatDialogRef<DossierAlerteDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private tagTiersService: TagTiersService,
        dialogService: DialogService,
        changeDetectorRef: ChangeDetectorRef,
    ) {
        super(dialogRef, dialogService, changeDetectorRef)
    }

    ngOnInit(): void {
        this.result.alerte.tiers = this.data.tiers.ID
        this.tagTiersService.getTiersTypeTags(this.data.tiers.type).pipe(first()).subscribe((data) => {
            this.tags = data.result
            this.showListOfAlerts = this.tags.length > 0
        })


    }
    changedTag(event: any) {
        console.log(event, 'changedTag')
    }

}